import React, { FC } from 'react';
import { Menu } from 'antd';
import {
  Switch, useLocation, Route, useHistory, Redirect, useRouteMatch,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Page } from '~/Components';
import { ProfileInfo } from '~/Views/Main/Profile/Info';
import { Passkeys } from '~/Views/Main/Profile/Passkeys';

import styles from './Profile.module.less';
import { Invitation } from './Invitation';

export const Profile:FC<any> = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();

  const navigate = (path:string) => {
    history.push(`${match.path}${path}`);
  };

  const paths = [
    {
      key: 'info',
      path: '',
      title: t('profile.info'),
      component: ProfileInfo,
    },
    {
      key: 'passkeys',
      path: '/passkeys',
      title: t('profile.passkeys'),
      component: Passkeys,
    },
    {
      key: 'inv',
      path: '/invitation',
      title: t('profile.invitation'),
      component: Invitation,
    },
  ];

  const activeKeys = ():string => {
    const currentTab = paths.find((p) => `${match.path}${p.path}` === location.pathname);
    return currentTab ? currentTab.key : 'info';
  };

  return (
    <>
      <Menu mode="horizontal" selectedKeys={[activeKeys()]} style={{ background: '#FFF' }}>
        {paths.map(({ key, path, title }) => (
          <Menu.Item key={key} onClick={() => navigate(path)}>{title}</Menu.Item>
        ))}

      </Menu>
      <Page title={t('profile.title')} className={styles.Profile}>
        <Switch>
          {paths.map(({ key, path, component: Component }) => (
            <Route key={key} exact path={`${match.path}${path}`} component={Component} />
          ))}

          <Redirect to="/profile" />
        </Switch>
      </Page>
    </>
  );
};